// @flow
import type { Event } from '~/core/types/beekeeper/actions/events';
import type { AllowedType } from '../types';

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import SVGIcon from '~/core/icons/svg-icons';
import messages from '../../../intl';
import { AddEventContainer, AddEventIcon, AllowedTypeItem, CancelAdding, ShowDetail } from './styles';

type Props = {
    addActionAttribute: ({ event: Event }) => {},
    allowedTypes: Array<AllowedType>
};
type State = {
    isDetailVisible: boolean
};
export default class AddEvent extends Component<Props, State> {
    state = {
        isDetailVisible: false
    };

    showDetailVisibility = () => this.setState({ isDetailVisible: true });
    hideDetailVisibility = () => this.setState({ isDetailVisible: false });

    render() {
        const { addActionAttribute, allowedTypes } = this.props;
        const { isDetailVisible } = this.state;
        return (
            allowedTypes.some(item => item.available) && (
                <AddEventContainer isDetailVisible={isDetailVisible} numberElements={allowedTypes.length}>
                    {isDetailVisible ? (
                        [
                            allowedTypes.map(item => (
                                <AllowedTypeItem
                                    disabled={!item.available}
                                    key={item.event.type}
                                    onClick={
                                        item.available
                                            ? () => {
                                                  this.hideDetailVisibility();
                                                  addActionAttribute({ event: item.event });
                                              }
                                            : null
                                    }
                                >
                                    <AddEventIcon disabled={!item.available}>
                                        <SVGIcon type={item.icon} />
                                    </AddEventIcon>
                                    <FormattedMessage {...item.label} />
                                </AllowedTypeItem>
                            )),
                            <CancelAdding key="cancel" onClick={this.hideDetailVisibility}>
                                <FormattedMessage {...messages.cancelAttribute} />
                            </CancelAdding>
                        ]
                    ) : (
                        <ShowDetail onClick={this.showDetailVisibility}>
                            <SVGIcon type={generalIcons.PLUS} />
                        </ShowDetail>
                    )}
                </AddEventContainer>
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/action-detail/add-event/component.js